// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_dv-3";
export var flatBottomCorners = "_dv-5";
export var productImage = "_dv-0";
export var quantityContainer = "_dv-2";
export var quantityHeader = "_dv-6";
export var tooltip = "_dv-1";
export var wrapAndEllipsesOverflow = "_dv-4";